import { render, staticRenderFns } from "./Comportamiento.vue?vue&type=template&id=f88f05ae"
import script from "./Comportamiento.vue?vue&type=script&lang=js"
export * from "./Comportamiento.vue?vue&type=script&lang=js"
import style0 from "./Comportamiento.vue?vue&type=style&index=0&id=f88f05ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports